import React from "react";
import { Table, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ButtonSendActivationMail from "../Button/ButtonSendActivationMail";

const TeacherTable = (props) => {
  var teachers = props.teachers;

  if (props.filter && props.filter.length > 0) {
    teachers = props.teachers.filter((t) => {
      return (
        t.name.toLowerCase().indexOf(props.filter) !== -1 ||
        t.email.toLowerCase().indexOf(props.filter) !== -1
      );
    });
  }

  var mappedTeachers = teachers.map((teacher, id) => {
    return (
      <tr key={id}>
        <td>
          <Button
            color="link"
            disabled={!props.fullAccess}
            onClick={() => props.updateTeacher(teacher)}
            title={
              props.fullAccess
                ? "Klicka för att uppdatera: " + teacher.name
                : "Du har inte behörighet att uppdatera andra lärare"
            }
          >
            {teacher.name}
          </Button>
        </td>
        <td>{teacher.email}</td>
        <td>{teacher.purchaser ? "Ja" : "Nej"}</td>
        <td>{teacher.fullAccess ? "Ja" : "Nej"}</td>
        <td>
          <ButtonSendActivationMail className="float-end" user={teacher} />
        </td>
        <td>
          <Button
            hidden={props.editable === false}
            onClick={() => props.detachTeacher(teacher)}
            size="sm"
            color="danger"
            outline
            className={"float-end"}
          >
            <FontAwesomeIcon icon="trash" />
          </Button>
        </td>
      </tr>
    );
  });

  return (
    <Table hover responsive striped className="school-table">
      <thead>
        <tr>
          <th hidden={!props.selectable} />
          <th>Namn</th>
          <th>E-post</th>
          <th>Inköpare</th>
          <th>Full åtkomst</th>
          <th />
          <th />
        </tr>
      </thead>
      <tbody>{mappedTeachers}</tbody>
    </Table>
  );
};

export default TeacherTable;
